<form [formGroup]="berekeningFormGroup">
    <div formGroupName="box1">
        <div class="row">
            <div class="col col-1 pt-3">
                <p>Inkomen box 1</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="inkomen"
                                                  id="inkomenbox1"
                                                  label="Inkomen"
                                                  prefix="€"
                ></snelstart-ui-number-form-control>
            </div>
            <div class="col-3">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="persoonsgebondenAftrek"
                                                  label="Persoonsgeb. aftrek"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150'"
                                                  formControlName="belastbaarInkomen"
                                                  label="Belastbaar inkomen"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div formGroupName="box2">
        <div class="row">
            <div class="col col-1">
                <p>Inkomen box 2</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="inkomen"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="persoonsgebondenAftrek"
                                                  id="persoonsgebondenAftrekbox2"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="belastbaarInkomen"
                                                  id="belastbaarInkomenbox2"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div formGroupName="box3">
        <div class="row">
            <div class="col col-1">
                <p>Inkomen box 3</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="inkomen"
                                                  id="inkomenbox3"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-3">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="persoonsgebondenAftrek"
                                                  id="persoonsgebondenAftrekbox3"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="belastbaarInkomen"
                                                  id="belastbaarInkomenbox3"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div class="row">
        <div *ngIf="!this.partnerBoolean" class="col col-1" style="font-weight: bold">
            <p>Verzamelinkomen {{ this.aangifte.aangifteJaar }} voor {{ dataService.naamAangever }}</p>
        </div>
        <div *ngIf="this.partnerBoolean" class="col col-1" style="font-weight: bold">
            <p>Verzamelinkomen {{ this.aangifte.aangifteJaar }} voor {{ dataService.naamPartner }}</p>
        </div>
        <div class="col-4">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verzamelinkomen"
                                              id="verzamelinkomen"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-4"></div>
    </div>

    <div class="space20"></div>

    <div class="row">
        <div class="col col-1">
            <p>Inkomstenbelasting</p>
        </div>
        <div class="col-2">
            <div *ngIf="berekeningFormGroup.get('totaalInkomstenbelasting')?.value !== 0">
                <snelstart-ui-button (click)="this.showDialogSpecInkomstenbelasting()"
                                     class="custom-input-150"
                                     icon="magnifying-glass"
                                     type="secondary">
                    Specificatie
                </snelstart-ui-button>
            </div>
        </div>
        <div class="col-3">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="totaalInkomstenbelasting"
                                              prefix="€"
                                              placeholder="0"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-4"></div>
        <div class="col-4"></div>
    </div>

    <div class="row">
        <div class="col col-1">
            <p>Premie volksverzekeringen</p>
        </div>
        <div class="col-2">
            <div *ngIf="berekeningFormGroup.get('premieVolksverzekeringen')?.value !== 0">
                <snelstart-ui-button (click)="this.showDialogSpecPVV()"
                                     class="custom-input-150"
                                     icon="magnifying-glass"
                                     type="secondary">Specificatie
                </snelstart-ui-button>
            </div>
        </div>
        <div class="col-3">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="premieVolksverzekeringen"
                                              id="premieVolksverzekeringen"
                                              prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-4"></div>
        <div class="col-4"></div>
    </div>

    <div>
        <div class="row">
            <div class="col col-1">
                <p>Gecombineerde inkomensheffing</p>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="gecombineerdeInkomensheffing"
                                                  id="gecombineerdeInkomensheffing"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div *ngIf="berekeningFormGroup.getRawValue()?.voorlopigeAanslag !== null &&
                        berekeningFormGroup.getRawValue().voorlopigeAanslag !== undefined &&
                        berekeningFormGroup.get('voorlopigeAanslag')?.getRawValue() < 0">
        <div class="row">
            <div class="col col-1 ">
                <p>Bij: Ontvangen via voorlopige aanslag(en)</p>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="voorlopigeTeruggaaf"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div *ngIf="berekeningFormGroup.get('totaalInkomstenbelasting')?.value !== 0 ||
                                                  berekeningFormGroup.get('premieVolksverzekeringen')?.value !== 0 ||
                                                    berekeningFormGroup.get('heffingskortingen.totaal')?.value !== 0"
         formGroupName="heffingskortingen">
        <div class="row">
            <div class="col col-1 ">
                <p>Af: Heffingskortingen</p>
            </div>
            <div class="col-2">
                <snelstart-ui-button (click)="this.showDialogSpecHeffingskortingen()"
                                     class="custom-input-150"
                                     icon="magnifying-glass"
                                     type="secondary">Specificatie
                </snelstart-ui-button>
            </div>
            <div class="col-4"></div>
            <div class="col-3">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="totaal"
                                                  id="totaal" prefix="€ -"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div *ngIf="berekeningFormGroup.getRawValue().verrekendeBelastingKortingBox2 !== null &&
                    berekeningFormGroup.getRawValue().verrekendeBelastingKortingBox2 !== 0">
        <div class="row">
            <div class="col col-1 ">
                <p>Af: Belastingkorting box 2</p>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="verrekendeBelastingKortingBox2"
                                                  id="verrekendeBelastingKortingBox2" prefix="€ -"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div *ngIf="berekening.alBetaaldeLoonbelasting !== null &&
                    berekening.alBetaaldeLoonbelasting !== 0">
        <div class="row">
            <div class="col col-1 ">
                <p>Af: Ingehouden loonheffing</p>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="alBetaaldeLoonbelasting"
                                                  id="alBetaaldeLoonbelasting" prefix="€ -"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div *ngIf="berekeningFormGroup.getRawValue().alBetaaldeDividendbelasting !== null &&
                    berekeningFormGroup.getRawValue().alBetaaldeDividendbelasting !== 0">
        <div class="row">
            <div class="col col-1 ">
                <p>Af: Ingehouden dividendbelasting</p>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="alBetaaldeDividendbelasting"
                                                  id="alBetaaldeDividendbelasting" prefix="€ -"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div *ngIf="berekeningFormGroup.getRawValue()?.voorlopigeAanslag !== null &&
                    berekeningFormGroup.getRawValue().voorlopigeAanslag !== undefined &&
                    berekeningFormGroup.get('voorlopigeAanslag')?.getRawValue() > 0">
        <div class="row">
            <div class="col col-1 ">
                <p>Af: Betaalde via voorlopige aanslag(en)</p>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="voorlopigeAanslag"
                                                  id="voorlopigeAanslag"
                                                  prefix="€ -"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div *ngIf="berekeningFormGroup.getRawValue().aanslaggrens !== null && berekeningFormGroup.getRawValue().aanslaggrens !== 0">
        <div class="row">
            <div class="col col-1">
                <p>Af: Aanslaggrens</p>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control [decimals]="0"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="aanslaggrens"
                                                  id="aanslaggrens"
                                                  prefix="€ -"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>

    <div class="row">
        <div class="col col-1" style="font-weight: bold">
            <div *ngIf="!this.partnerBoolean">
                <p *ngIf="(berekening?.verschuldigdeInkomstenbelasting ?? 0) < 0">Te
                    ontvangen door {{ dataService.naamAangever }}</p>
                <p *ngIf="(berekening?.verschuldigdeInkomstenbelasting ?? 0) >= 0">Te
                    betalen door {{ dataService.naamAangever }}</p>
            </div>
            <div *ngIf="this.partnerBoolean">
                <p *ngIf="(berekening?.verschuldigdeInkomstenbelasting ?? 0) < 0">Te
                    ontvangen door {{ dataService.naamPartner }}</p>
                <p *ngIf="(berekening?.verschuldigdeInkomstenbelasting ?? 0) >= 0">Te
                    betalen door {{ dataService.naamPartner }}</p>
            </div>
        </div>
        <div class="col-4">
            <snelstart-ui-number-form-control [decimals]="0"
                                              align="right"
                                              class="custom-input-150"
                                              formControlName="verschuldigdeInkomstenbelasting"
                                              id="verschuldigdeInkomstenbelasting" prefix="€"
            >
            </snelstart-ui-number-form-control>
        </div>
        <div class="col-4"></div>
    </div>

</form>

<div class="space20"></div>


@if ((!partnerBoolean && (revisierenteForm.get('revisierenteAangever')?.value ?? 0) > 0) ||
(partnerBoolean && (revisierenteForm.get('revisierentePartner')?.value ?? 0) > 0)) {
    <div [formGroup]="revisierenteForm">
        <div class="row">
            <div class="col col-1" style="font-weight: bold">
                <p>Te betalen revisierente</p>
            </div>
            <div class="col-4">
                <snelstart-ui-number-form-control
                        [disabledControl]="true"
                        [decimals]="0"
                        align="right"
                        class="custom-input-150"
                        prefix="€"
                        [formControlName]="partnerBoolean ? 'revisierentePartner' : 'revisierenteAangever'">
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
}


<snelstart-ui-dialog-definition [(visible)]="this.dialogSpecInkomstenbelastingVisible" id="specIB"
                                size="lg"
                                title="Specificatie inkomstenbelasting">
    <snelstart-ui-dialog-body>
        <div [formGroup]="berekeningFormGroup">
            <snelstart-venture-fiscaal-feature-spec-belasting-box1
                    [partner]="partner"></snelstart-venture-fiscaal-feature-spec-belasting-box1>
            <snelstart-venture-fiscaal-feature-spec-belasting-box2
                    [partner]="partner"></snelstart-venture-fiscaal-feature-spec-belasting-box2>
            <snelstart-venture-fiscaal-feature-spec-belasting-box3
                    [partner]="partner"></snelstart-venture-fiscaal-feature-spec-belasting-box3>

            <div class="flex-container-dialog">
                <div class="flex-item-tekst-dialog pb-2">
                    <b>Totaal inkomstenbelasting</b>
                </div>
                <div class="flex-item-ruimte-dialog"></div>
                <snelstart-ui-number-form-control
                        [decimals]="0"
                        align="right"
                        class="custom-input-150"
                        formControlName="totaalInkomstenbelasting"
                        prefix="€"
                        placeholder="0"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x icon="check" id="saveIB" type="primary">Afsluiten
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<snelstart-ui-dialog-definition [(visible)]="dialogSpecPVVVisible" id="specPVV" size="lg"
                                title="Specificatie premie volksverzekeringen">
    <snelstart-ui-dialog-body>
        <div [formGroup]="berekeningFormGroup">
            <snelstart-venture-fiscaal-feature-spec-premie-volksverzekeringen
                    [partner]="partner"></snelstart-venture-fiscaal-feature-spec-premie-volksverzekeringen>

            <div class="flex-container-dialog">
                <div class="flex-item-tekst-dialog pb-2">
                    <p><b>Totaal premie volksverzekeringen</b></p>
                </div>
                <div class="flex-item-ruimte-dialog"></div>
                <snelstart-ui-number-form-control
                        [decimals]="0"
                        align="right"
                        class="custom-input-150"
                        formControlName="premieVolksverzekeringen"
                        id="premieVolksverzekeringenTot"
                        prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x icon="check" id="savPVV" type="primary">Afsluiten
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<snelstart-ui-dialog-definition [(visible)]="dialogSpecHeffingskortingenVisible" id="specHK" size="lg"
                                title="Specificatie heffingskortingen">
    <snelstart-ui-dialog-body>
        <div [formGroup]="berekeningFormGroup">
            <snelstart-venture-fiscaal-feature-berekeningen-heffingskortingen
                    [partner]="partner"></snelstart-venture-fiscaal-feature-berekeningen-heffingskortingen>
            <div formGroupName="heffingskortingen">
                <div class="flex-container-dialog">
                    <div class="flex-item-tekst-dialog pb-2">
                        Totaal heffingskortingen
                    </div>
                    <div class="flex-item-ruimte-dialog"></div>
                    <snelstart-ui-number-form-control
                            [decimals]="0"
                            align="right"
                            class="custom-input-150"
                            formControlName="totaal"
                            id="totaalHk"
                            prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
            </div>
        </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x icon="check" id="saveHK" type="primary">Afsluiten
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

